<template lang="pug">
	.creative--sub-insertions-recorder
		Popup(:popupVisible="popupVisible", :width="960", :height="570" @hiding="v => popupVisible = false", :closeOnOutsideClick="false")
			.flex-col.space-large.creative--sub-insertions-recorder.full-height(slot="body")
				.flex-col.space
					.font-large {{$tCaption('Sub-tracks recorder')}}
					.help.flex-row.space.align-center.grey.font-small(v-if="isRecorderTab")
						.flex-row.space.align-center
							span {{$tCaption('Press')}}
							.key-button
								fas(icon="arrow-left")
							span {{$tCaption('or')}}
							.key-button
								fas(icon="arrow-up")
							span {{$tCaption('to navigate back')}},
						.flex-row.space.align-center
							.key-button
								fas(icon="arrow-right")
							span {{$tCaption('or')}}
							.key-button
								fas(icon="arrow-down")
							span {{$tCaption('to navigate forward')}},
						.flex-row.space.align-center
							.key-button {{$tCaption('SPACE')}}
							span {{$tCaption('to start/stop recording')}},
						.flex-row.space.align-center
							.key-button {{$tCaption('ENTER')}}
							span {{$tCaption('to play')}}.
				.flex-row.recorder-body
					.flex-col.space.flex-1
						.flex-row.justify
							.left
							.flex-row.align-center.space.phrases-actions
								.recorder-button.flex-row.align-center.center.space(v-if="phrases.length", @click="removeAllPhrases", :title="$tCaption('Clear')")
									fas(icon="trash", size="sm")
									span(v-if="!isRecorderTab") {{$tCaption('Clear')}}
								.recorder-button.flex-row.align-center.center.space(@click="showMemoPhrasesPopup", :title="$tCaption('Add phrases')")
									fas(icon="list", size="sm")
									span(v-if="!isRecorderTab") {{$tCaption('Add phrases')}}
								.recorder-button.flex-row.align-center.center.space(@click="showExcelLoader", :title="$tCaption('Import from Excel')")
									fas(icon="file-excel", size="sm")
									span(v-if="!isRecorderTab") {{$tCaption('Import from Excel')}}
						DxScrollView.phrases-scroll(:height="!isRecorderTab ? 280 : 320", showScrollbar="always", ref="phrasesScroll")
							.flex-col.space
								.font-big.grey.flex-row.full-width.full-height.align-center.center(v-if="!phrases.length", :style="{ height: '280px' }") {{$tCaption('Add speech phrases to record or import them from Excel')}}
								.phrase.flex-row.align-center.justify(v-for="(phrase, index) in phrases", ref="phrases" :class="{ 'selected accent-bg accent-color': index === recordingPhraseIndex && isRecorderTab, 'done': phrase.status === 1 }")
									.left.clickable.text-overflow.flex-row.align-center.space(@click="recordingPhraseIndex = index", :class="{ 'phrase-text-overflow nowrap': isRecorderTab }")
										fas(v-if="phrase.status === 1", icon="check")
										span {{index + 1}}.
										span {{phrase.text}}
									.right.flex-row.align-center.space
										.adt-button.clickable.rounded.flex-row.align-center.center(@click="removePhrase(phrase, index)")
											fas(icon="times")
					.flex-col.space-medium.align-center.center.recorder-tab.flex-3(v-if="isRecorderTab")
						template(v-if="recordingPhrase")
							.speaking-text-frame.font-big.accent-color.full-width.flex-col
								.flex-row.flex-1.location.space-small.font-tiny.grey.align-center.center(v-if="geoTarget.address")
									Loader(v-if="processGeoTarget().processing")
									template(v-else)
										fas(icon="location-dot")
										span {{geoTarget.address}}
								.flex-row.align-center
									.nav-button.flex-row.align-center.center(v-if="phrases.length > 1", :title="$tCaption('Prev phrase')", @click="nextPhrase(-1)")
										.font-upper
											fas(icon="chevron-left")
									DxScrollView.flex-1(:height="100")
										.speaking-text.align-center.center.flex-row
											.flex-col.space
												span {{recordingPhrase.text}}
									.nav-button.flex-row.align-center.center(v-if="phrases.length > 1", :title="$tCaption('Next phrase')", @click="nextPhrase(1)")
										.font-upper
											fas(icon="chevron-right")
							AudioTrackerRecorder.full-width(v-if="popupVisible", ref="recorder", :tracker="tracker", :track="track", :audioContext="tracker.audioContext", 
								:showUI="false", :showTitle="false", :showHeader="false")
								template(slot="actions")
									.flex-row.space
										Loader.accent-color(v-if="recordingPhrase.processing", :text="$tCaption('Saving results.. You can skip it and go to the next phrase.', )")
										template(v-else)
											template(v-if="!isRecording")
												template(v-if="!recordingPhrase.base64Wav")
													DxButton.flex-1(:text="$tCaption('Upload')", icon="fas fa-upload", @click="$refs.audioUploader.showPopup()", type="normal", :focusStateEnabled="false")
													DxButton.flex-1(:text="$tCaption('Record')", icon="fas fa-circle", @click="record", type="danger", :focusStateEnabled="false")
												template(v-else)
													DxButton.flex-1(v-show="!tracker.isPlaying", :text="$tCaption('Play')", icon="fas fa-play", @click="playEditingRecord(true)", type="normal", :focusStateEnabled="false")
													DxButton.flex-1(v-show="tracker.isPlaying", :text="$tCaption('Stop')", icon="fas fa-stop", @click="playEditingRecord(false)", type="normal", :focusStateEnabled="false")
													DxButton.flex-1(:text="$tCaption('Re-take')", icon="fas fa-rotate-right", @click="record", type="danger", :focusStateEnabled="false")
											DxButton.flex-1(v-if="isRecording", :text="$tCaption('Stop', '@actions')", icon="fas fa-stop", @click="saveRecordedData", type="normal", :focusStateEnabled="false")
				.flex-row.justify.bottom-actions
					.left
					.flex-row.space
						DxButton(:text="$tCaption('Close', '@actions')", @click="popupVisible = false")
		Popup(v-if="phrasesMemoPopupVisible", :popupVisible="phrasesMemoPopupVisible", :width="540", :height="450")
			.creative--sub-insertions-recorder
				.flex-col.space
					span {{$tCaption('Add each phrase in a separate row.')}}
					DxTextArea.phrases-memo(:value.sync="phrasesMemoValue", height="320px")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="phrasesMemoPopupVisible = false")
				DxButton(:text="$tCaption('Add phrases', '@actions')", type="success", @click="addMemoPhrases")
		FileUploader(
			ref="uploader",
			:dropZoneHeight="600",
			:dropText="$tCaption('Drop excel file with speech values here')",
			:isUIHidden="true",
			:closeOnOutsideClick="false",
			:popupConfig="{ height: 710 }",
			:error-message="fileErrorMessage",
			:accept="['.xls', '.xlsx']",
			:multiple="false",
			@file-selected="onExcelSelected",
			@upload="processExcelRows"
		)
			.flex-col.space-medium(v-if="excelColumns.length")
				.flex-col.field
					.font-small.upper.grey {{$tCaption('Address field')}}
					DxSelectBox(:items="excelColumns", :value.sync="addressField")
				.flex-col.field
					.font-small.upper.grey {{$tCaption('Speech value field')}}
					DxSelectBox(:items="excelColumns", :value.sync="speechField")
		FileUploader(
			ref="audioUploader",
			:dropZoneHeight="600",
			:dropText="$tCaption('Drop audio file here')",
			:isUIHidden="true",
			:closeOnOutsideClick="false",
			:popupConfig="{ height: 710 }",	
			:accept="['.wav', '.mp3', '.riff']",
			:multiple="false",
			@upload="uploadAudio"
		)
</template>

<script>
	import FileUploader from 'app-core/FileUploader.vue';
	import DxButton from 'devextreme-vue/button';
	import readXlsxFile from 'read-excel-file';
	import Popup from 'app-core/Popup.vue';
	import DxTextArea from 'devextreme-vue/text-area';
	import DxScrollView from 'devextreme-vue/scroll-view';
	import DxSelectBox from 'devextreme-vue/select-box';
	import Loader from 'app-core/Loader.vue';
	import wkt from 'wicket';
	import AudioTrackerRecorder from 'view/audioTracker/AudioTrackerRecorder.vue';
	import storage from 'storage';

	export default {
		translationCategory: 'creative.Detail.SubInsertionsRecorder',
		name: 'creative--sub-insertions-recorder',
		components: {
			DxButton, FileUploader, Popup, DxTextArea, DxScrollView, DxSelectBox, Loader, AudioTrackerRecorder
		},
		props: ['tracker', 'track', 'subTrackResolver'],
		data() {
			return {
				popupVisible: false,
				phrases: [],
				phrasesMemoPopupVisible: false,
				phrasesMemoValue: null,
				excelColumns: [],
				excelRows: [],
				fileErrorMessage: null,
				addressField: null,
				speechField: null,
				recordingPhraseIndex: 0,
				savedPhrases: null,
				phrasesChanged: false,
				isRecording: false
			};
		},
		computed: {
			isRecorderTab() {
				return this.phrases.length;
			},
			recordingPhrase() {
				this.navigateToElem();
				return this.phrases[this.recordingPhraseIndex];
			},
			targetTime() {
				return this.$Data.formatNumber(this.track.getTrimmedDuration().toFixed(1));
			},
			geoTarget: {
				get: function() {
					if (this.recordingPhrase && !this.recordingPhrase.geoTarget) {
						this.$set(this.recordingPhrase, 'geoTarget', {});
					}
					return this.recordingPhrase?.geoTarget || {};
				},
				set: function(v) {
					this.$set(this.recordingPhrase, 'geoTarget', v);
				}
			}
		},
		watch: {
			popupVisible(v) {
				if (!v) {
					this.storeUnprocessedPhrases();
				}
				this.addKeyHandles(v);
			},
			phrases: {
				handler() {
					this.phrasesChanged = true;
					this.storeUnprocessedPhrases(true);
				},
				deep: true
			}
		},
		mounted() {
			if (__DEBUG__)
				window.subInsertionsRecorder = this;

			this.addKeyHandles(true);
		},
		destroyed() {
			this.addKeyHandles(false);
		},
		methods: {
			addKeyHandles(v) {
				document.removeEventListener('keyup', this.keyHandler);
				if (v)
					document.addEventListener('keyup', this.keyHandler);
			},
			record() {
				if (this.$refs.recorder) {
					this.isRecording = true;
					this.$refs.recorder.init(this.getRecorderOpts());
				}
			},
			getRecorderOpts() {
				if (!this.recordingPhrase) return null;
				return {
					trackerPosition: this.track.start,
					autoStart: this.isRecording ? 2 : 0,
					countdownTime: this.track.getTrimmedDuration()
				}
			},
			saveRecordedData() {
				const instance = this.$refs.recorder;
				const recorder = instance?.recorder;
				const phrase = this.recordingPhrase;
				return instance?.stopRecording().then(() => {
					this.isRecording = false;
					this.onVoiceRecorded(phrase, recorder.resultWav, instance.title, recorder.trackerInitPosition, instance.fileUploading);
					this.$refs.recorder.init();
				});
			},
			removeAllPhrases() {
				this.$confirmMessage({
					title: this.$tCaption('Confirm action', '@actions'),
					text: this.$tCaption('Do you want to delete the phrases?'),
					handler: () => {
						this.phrases = [];
					}
				});
			},
			keyHandler(e) {
				if (!this.popupVisible || !this.isRecorderTab) return;
				if (`${document.activeElement?.tagName}`.toLowerCase() === 'input') return;

				const isRecording = this.isRecording;
				const checkNewRecordPossible = (callback) => {
					if (isRecording) {
						this.saveRecordedData().then(() => {
							callback();
							setImmediate(() => {
								if (this.recordingPhrase.status !== 1)
									this.record();
							});
						});
					} else {
						callback();
					}
				};
				if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
					checkNewRecordPossible(() => this.nextPhrase(1));
				} else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
					checkNewRecordPossible(() => this.nextPhrase(-1));
				} else if (e.keyCode === 32) {
					if (!this.tracker.isPlaying) {
						this.record();
					} else {
						this.saveRecordedData();
					}
				} else if (e.key === 'Enter') {
					this.playEditingRecord(!this.tracker.isPlaying);
				}
			},
			storeUnprocessedPhrases(preventMessage) {
				if (!this.savedPhrases || !this.phrasesChanged) return;
				this.savedPhrases.value = this.phrases.filter(f => f.status !== 1).map(f => ({
					text: f.text,
					geoTarget: {
						address: f.geoTarget?.address,
						radius: f.geoTarget?.radius,
						latitude: f.geoTarget?.latitude,
						longtitude: f.geoTarget?.longtitude
					}
				}));
				if (this.savedPhrases.value.length && !preventMessage) {
					this.$notifySuccess(this.$tCaption('Unprocessed phrases have been stored locally. You can continue later.'));
				}
			},
			navigateToElem() {
				setImmediate(() => {
					if (this._isDestroyed) return;
					this.$refs.phrasesScroll.instance.scrollToElement(this.$refs.phrases[this.recordingPhraseIndex]);
				});
			},
			async findGeoTarget(geoTarget) {
				const osPlaces = await this.$Data.getLocationGeoJson({ q: geoTarget.address });
				const osPlace = osPlaces[0];
				let geoJsonItem = osPlace?.geojson;
				let geoJson = `${geoJsonItem?.type}`.toLowerCase().indexOf('polygon') > -1 ? geoJsonItem : null;

				let latLngRadius = {
					Radius: geoTarget.radius,
					Lat: geoTarget.latitude || parseFloat(osPlace.lat),
					Lng: geoTarget.longtitude || parseFloat(osPlace.lon),
					IsUserDefined: true
				}

				let target = {
					Name: geoTarget.address,
					...(geoTarget.radius ? latLngRadius : {})
				};

				if (!geoTarget?.radius && geoJson) {
					let wktObject = new wkt.Wkt();
					wktObject.fromJson(geoJson);
					target.GeoPolygonWkt = wktObject.toString();
					target.IsUserDefined = false;
				}

				if (__DEBUG__)
					console.debug('Geo target', target);

				if (target.IsUserDefined) {
					let possibleOwnTargets = (await this.$Data.postExternalApi('Target/GetMyPossibleTargets', target, 5))?.Results || [];					
					geoTarget.object = possibleOwnTargets.find(f => f.Lng === target.Lng && f.Lat === target.Lat && f.Radius === target.Radius);

					if (__DEBUG__)
						console.debug('possibleOwnTargets', { possibleOwnTargets, tar: geoTarget.object });
				}
				
				if (!geoTarget.object) {
					geoTarget.object = (await this.$Data.postExternalApi('Target/CreateUpdateGeoTarget', target))?.Data;
				}
			},
			processGeoTarget() {
				const geoTarget = this.geoTarget;
				if (!geoTarget.processed && !geoTarget.object) {
					if (!geoTarget.processing) {
						if (!geoTarget.address) {
							this.$set(geoTarget, 'processing', false);
							this.$set(geoTarget, 'processed', true);
						} else {
							this.$set(geoTarget, 'processing', true);
							
							this.findGeoTarget(geoTarget).finally(() => {
								this.$set(geoTarget, 'processing', false);
								this.$set(geoTarget, 'processed', true);
							});
						}
					}
				}
				return geoTarget;
			},
			uploadAudio(files) {
				if (files.length > 0) {
					const phrase = this.recordingPhrase;
					let fr = new FileReader;
					fr.onloadend = () => {
						this.onVoiceRecorded(phrase, fr.result, files[0].name);
					}
					fr.readAsDataURL(files[0]);
				}
			},
			playEditingRecord(playing) {
				if (!this.recordingPhrase?.track) return;
				if (playing) {
					this.$soloSubTrackIds = this.tracker.soloSubTrackIds;
					this.tracker.soloSubTrackIds = [this.recordingPhrase.track.id];
					setTimeout(() => {
						this.tracker.play(this.track.start);
					}, 100);
				}
				else {
					this.tracker.stop(true);
					this.tracker.soloSubTrackIds = [];
				}
			},
			onVoiceRecorded(recordingPhrase, base64Wav, title, startPosition, trimSettings) {
				if (__DEBUG__)
					console.debug('Recorded', { base64Wav, title, startPosition, trimSettings });

				recordingPhrase.status = 1;
				
				this.$set(recordingPhrase, 'base64Wav', base64Wav);
				this.$set(recordingPhrase, 'processing', true);

				return this.subTrackResolver(this.track, base64Wav, title || 'speech_value', { Name: `${recordingPhrase.text}`.slice(0, 99) }, { 
					editingTrack: recordingPhrase.track, 
					preventEditingTrack: !recordingPhrase.track, 
					fileUploading: trimSettings
				}).then(async r => {
					if (__DEBUG__)
						console.debug('Sub track created', { r });
					if (recordingPhrase.geoTarget.object && r.insertion.Targets.length === 0) {
						const linkedTarget = {
							ObjectId: r.id,
							ObjectType: this.$Data.objectTypes.BaseInsertion,
							Name: recordingPhrase.geoTarget.object.Name,
							LinkedTarget: {
								Oid: recordingPhrase.geoTarget.object.Oid,
								Name: recordingPhrase.geoTarget.object.Name
							},
							InsertionOid: r.id
						};
						r.insertion.Targets.push(linkedTarget);
						await this.$Data.postExternalApi('Target/LinkTarget', [linkedTarget]);
					}
					this.$set(recordingPhrase, 'track', r);
					return r;
				}).finally(() => this.$set(recordingPhrase, 'processing', false));
				
			},
			nextPhrase(direction) {
				let newIndex = this.recordingPhraseIndex + direction;
				if (newIndex > this.phrases.length - 1) {
					newIndex = 0;
				} else if (newIndex < 0) {
					newIndex = this.phrases.length - 1;
				}
				
				this.recordingPhraseIndex = newIndex;
			},
			removePhrase(phrase, index) {
				if (phrase.status === 0) {
					this.phrases.splice(index, 1);
				} else {
					this.$confirmMessage({
						title: this.$tCaption('Confirm action', '@actions'),
						text: this.$tCaption('Do you want to delete the phrase?'),
						handler: () => {
							this.phrases.splice(index, 1);
						}
					});
				}
			},
			showMemoPhrasesPopup() {
				this.prhasesMemoValue = null;
				this.phrasesMemoPopupVisible = false;
				setImmediate(() => {
					this.phrasesMemoPopupVisible = true;
				});
			},
			addMemoPhrases() {
				`${this.phrasesMemoValue}`.split('\n').map(f => {
					this.phrases.push({
						text: f,
						status: 0,
						geoTarget: {
							address: null,
							object: null
						},
						base64Wav: null
					})
				});
				this.phrasesMemoValue = null;
				this.phrasesMemoPopupVisible = false;
			},
			show() {
				this.popupVisible = false;
				this.recordingPhraseIndex = 0;
				this.isRecording = false;
				setImmediate(() => {
					this.savedPhrases = storage.prop(`subInsertionsRecorder_savedPhrases_${this.track.id}`, void 0, []);
					this.phrases = this.savedPhrases.value.map(f => ({
						text: f?.text,
						status: 0,
						geoTarget: {
							address: f?.geoTarget?.address,
							radius: f?.geoTarget?.radius,
							longtitude: f?.geoTarget?.longtitude,
							latitude: f?.geoTarget?.latitude
						}
					}));
					this.popupVisible = true;
					setImmediate(() => {
						this.phrasesChanged = false;
					})
				});
			},
			processData() {
				this.popupVisible = false;
			},
			showExcelLoader() {
				this.excelColumns = [];
				this.excelRows = [];
				this.$refs.uploader.showPopup();
			},
			onExcelSelected(files) {
				if (files.length > 0) {
					readXlsxFile(files[0])
						.then((rows) => {
							this.excelRows = rows;
							const blankExcelRow = rows.find(r => r.every(c => c === null));
							if (!blankExcelRow) {
								this.excelColumns = rows.find(r => !r.some(c => c === null));

								this.addressField = this.excelColumns.find(v => v === 'Address');
								this.speechField = this.excelColumns.find(v => `${v}`.indexOf('Speech') > -1) || this.excelColumns[0];
							} else {
								this.fileErrorMessage = this.$tCaption('The selected excel file must not contain blank lines at the beginning!');
								this.$notifyError(this.fileErrorMessage);
							}
						});
				}
			},
			processExcelRows() {
				const addressIndex = this.excelColumns.findIndex(f => f === this.addressField);
				const speechIndex = this.excelColumns.findIndex(f => f === this.speechField);
				const radiusIndex = this.excelColumns.findIndex(f => `${f}`.toLowerCase() === 'radius');
				const longtitudeIndex = this.excelColumns.findIndex(f => `${f}`.toLowerCase() === 'longtitude');
				const latitudeIndex = this.excelColumns.findIndex(f => `${f}`.toLowerCase() === 'latitude');

				this.excelRows.slice(1,9999).map(row => {
					if (row[speechIndex])
						this.phrases.push({
							text: row[speechIndex],
							status: 0,
							geoTarget: {
								address: row[addressIndex],
								radius: row[radiusIndex],
								longtitude: row[longtitudeIndex],
								latitude: row[latitudeIndex],
								object: null
							},
							base64Wav: null
						})
				});
			}
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.creative--sub-insertions-recorder {
		position: relative;

		.phrase {
			padding: 10px;
			border-radius: 4px;

			&:not(.selected) {
				background: rgba(0,0,0,0.03);

				&.done {
					background: rgb(217 217 217);
					color: #333;
				}
			}
		}

		.phrases-memo {
			background: #adadad17;
			padding: 10px;
			white-space: nowrap;
		}

		.recorder-tab {
			//height: 340px;
			padding: 10px;
			border-radius: 4px;
			background: #f7f7f7;
		}

		.record-button {
			width: 40px;
			height: 40px;
			border-radius: 40px;
			background: red;
		}

		.phrases-scroll {
		}

		.nav-button {
			--size: 60px;
			width: var(--size);
			height: var(--size);
			border-radius: var(--size);
			background: rgba(0,0,0,0.05);
			color: #333;
			font-size: 20px;
			transition: 0.3s;
			cursor: pointer;
			user-select: none;
			margin: 10px;

			&:hover {
				background: $base-accent;
				color: $base-bg;
			}
		}

		.phrase-text-overflow {
			max-width: 250px;
		}

		.recorder-body {
			//height: 350px;
		}

		.key-button {
			--size: 20px;
			box-sizing: border-box;
			line-height: var(--size);
			font-size: 10px;
			text-align: center;
			min-width:  var(--size);
			color: #555;
			cursor: pointer;
			height:  var(--size);
			border-color: #f2f2f2;
			border-style: solid;
			padding: 0px 2px 0px 2px;
			text-shadow: 0 0.5px 1px #777, 0 2px 6px #f2f2f2;
			border-width: 1px;
			border-radius: 4px;
			background: -webkit-linear-gradient(top, #f9f9f9 0%, #D2D2D2 80%, #c0c0c0 100%);
			font-family: sans-serif;
			display: inline-block;
			transition: box-shadow 0.3s ease, transform 0.15s ease;
			box-shadow: 0 0 1px #888,0 1px 0 #fff, 0 2px 0 #C0C0C0, 0 4px 17px rgba(#444, 0.1), 2px 1px 4px rgba(#444, 0.15), -2px 1px 4px rgba(#444, 0.25), 0 4px 16px rgba(#444, 0.1);
		}

		.bottom-actions {
			position: absolute;
			bottom: 0px;
			left: 0px;
			width: 100%;
		}

		.recorder-button {
			padding: 6px 10px;
			background: #f7f7f7;
			border: 1px solid #e6e6e6;
			border-radius: 4px;
			cursor: pointer;
			min-width: 30px;
			min-height: 30px;

			&:hover {
				background: $base-accent;
				color: $base-bg;
			}

			&.red {
				background: #f67070;
				color: #fff;
			}
		}

		.phrases-actions {
			margin-right: 6px;
		}
		
		.speaking-text-frame {
			box-shadow: 0px 0px 33px 0px rgba(34, 60, 80, 0.2);
			border-radius: 4px;
			padding: 8px;
			position: relative;

			.speaking-text {
				min-height: 100px;
			}

			> .location {
				position: absolute;
				left: 0;
				width: 100%;
				pointer-events: none;
				bottom: 8px;
			}
		}
	}
</style>
